import { useLanguage } from '../../../context/LanguageContext';
function AnnouncementBar() {
  const { translate } = useLanguage();
  return (
    <div className="announcement-bar">
      <div className="container announcement-bar__inner">
        <span className="announcement-bar__message">{translate('Traditional Siddha and Herbal Wellness')}</span>
        <div className="announcement-bar__support">
          <a href="tel:+917530037100">{translate('Customer Support')}: +91 75300 37100</a>
          <span aria-hidden="true">•</span>
          <span>{translate('Monday–Saturday: 10:00 AM–5:00 PM')}</span>
        </div>
      </div>
    </div>
  );
}
export default AnnouncementBar;
